import api from "../../../shared/services/api";
import { toast } from "react-toastify";

export default async function loadReportService(startDate, endDate) {
    try {
        if (!startDate || !endDate) return null;
        const response = await api.get("/relatorio-produtos/relatorio", {
            params: { data_inicio: startDate, data_fim: endDate }
        });
        return response;
    } catch (err) {
        console.error("❌ Erro ao carregar relatório de produtos:", err);
        toast.error("Erro ao carregar relatório de produtos");
        return null;
    }
}
